// ════════════════════════════════════════════════════════════
// /login — ECR
// ════════════════════════════════════════════════════════════
// Page de connexion fullscreen (pas de Layout shell).
// Support du paramètre ?redirect= pour revenir où l'user voulait.
// ════════════════════════════════════════════════════════════
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { LoginForm } from '@/components/auth/LoginForm';
import { useAuthStore } from '@/store/useAuthStore';

const loginSearchSchema = z.object({
  // Sécurité : on n'accepte qu'un chemin interne. Un `redirect` commençant par
  // '//' (protocol-relative) ou par un schéma (http:, javascript:) pourrait
  // rediriger hors-site après login → on l'ignore (fallback '/').
  redirect: z
    .string()
    .optional()
    .transform((r) => (r && r.startsWith('/') && !r.startsWith('//') ? r : undefined)),
});

export const Route = createFileRoute('/login')({
  validateSearch: loginSearchSchema,
  beforeLoad: ({ search }) => {
    const { session, isLoading } = useAuthStore.getState();
    if (!isLoading && session) {
      // TanStack Router pattern + typing du search dépend de routeTree.gen.ts
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: search.redirect ?? '/' });
    }
  },
  component: LoginForm,
});
